import type { IntlShape } from 'react-intl'

export default function getInclusionMinStayText(inclusion: App.OfferInclusion | App.PackageInclusion, intl: IntlShape) {
  const minDuration = inclusion?.minDuration
  const maxDuration = inclusion?.maxDuration

  if (minDuration && minDuration > 1 && minDuration !== maxDuration) {
    return intl.formatMessage(
      {
        id: 'CFodkXP_l1MqGCw6Omu_',
        defaultMessage: '({minDuration, plural, one {#+ night} other {#+ nights}})',
      },
      { minDuration: inclusion.minDuration },
    )
  }

  return ''
}
